module.exports = __webpack_public_path__ + "static/media/payIcon.f86ad6c0.png";